module.exports = __webpack_public_path__ + "img/cf.2171101e.svg";